import ErrorPage from './ErrorPage';
import { ErrorPageProps, ErrorPageValueProps } from './types';

export type { ErrorPageProps, ErrorPageValueProps };
export default ErrorPage;
